<template>
  <div class="item">
    <h3>{{ index }}. {{ text }}</h3>

    <ul v-if="subtexts.length > 0" :style="`list-style: ${listStyle}`">
      <li v-for="(item, index) in subtexts" :key="index" class="mb-0">
        {{ item }}
      </li>
    </ul>
    <slot></slot>

    <!-- ValidationProvider에 name 넣으면 안됨 -->
    <ValidationProvider rules="radio_false" v-slot="{ errors }" tag="div" class="mt-3">
      <v-radio-group v-model="innerValue" row hide-details dense class="mt-0 pt-0" :error="errors.length > 0"
        @change="$emit('update:radioValue', $event)">
        <v-radio v-for="n in 2" :key="n" :label="n === 1 ? '예' : '아니오'" :value="n === 1 ? true : false"
          class="mb-0"></v-radio>
      </v-radio-group>
      <v-slide-y-transition>
        <p v-if="errors.length > 0" class="position-absolute mt-4 font-size--10 error--text" :class="{ 'opacity-0': errors.length < 1 }">
          대출 제한 사유에 해당되는지 예/아니요로 체크해주세요.(진행불가)
        </p>
      </v-slide-y-transition>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    subtexts: {
      type: Array,
      default() { return [] }
    },
    /**
     * subtexts 용
     */
    listStyle: {
      type: String,
      default: 'disc'
    },
    radioValue: {
      type: Boolean
    }
  },
  data() {
    return {
      innerValue: this.radioValue
    }
  },
}
</script>

<style lang="scss" scoped>
.item {
  color: #333333;

  &:not(:last-of-type) {
    margin-bottom: 32px;
  }

  &:nth-of-type(even) {
    background-color: #f6faff;
  }

  padding: 12px;
  border: 1px solid #d7e1ea;
  border-radius: 10px;

  h3 {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  ul {
    font-size: 13px;
    font-weight: 400;
  }

  ::v-deep .v-input--radio-group__input {
    justify-content: flex-end;
  }
}
</style>
